<template>
  <div class="row col-12 post-item p-4 my-3">
    <user-data :user="post.user" :postID="post.id" @reloadPosts="reloadPosts"/>
    <post-content :text="post.text" />
    <post-media :medias="post.medias" />
    <like :postID="post.id" :liked="post.liked" :qtyLikes="post.qty_like" />
    <comments :postID="post.id" :commentsArray="post.comments" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import UserData from './User/UserData'
import PostMedia from './Media/PostMedia'
import PostContent from './Content/Content'
import Comments from './Comment'
import Like from './Likes/Likes'

export default {
  components: {
    "user-data": UserData,
    "post-media": PostMedia,
    "post-content": PostContent,
    "comments": Comments,
    "like": Like,
  },
  props: {
    post: {
      required: true
    }
  },
  methods: {
    reloadPosts: function () {
      this.$emit('reloadPosts')
    }
  }
}
</script>
